import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';
import { NotificationReceiptComponent } from './components/notification-receipt/notification-receipt.component';
import { TimeUntilNowPipe } from '../shared/pipes/time-until-now.pipe';
import { EllipsisActiveDirective } from './directives/ellipsis-active.directive';

@NgModule({
  declarations: [NotificationReceiptComponent, TimeUntilNowPipe, EllipsisActiveDirective],
  imports: [CommonModule, IconModule],
  exports: [NotificationReceiptComponent],
})
export class NotificationReceiptModule {}
